export default ({ request }) => ({
  changeOrderListApi(data = {}) {
    return request({
      url: '/factory/changeOrder/list',
      method: 'post',
      data,
    })
  },
  changeOrderListBySalesCodeApi(data = {}) {
    return request({
      url: '/factory/changeOrder/list/bySalesCode',
      method: 'post',
      data,
    })
  },
  changeOrderListGetChangeContentApi(data = {}) {
    return request({
      url: '/factory/changeOrder/list/getChangeContent',
      method: 'post',
      data,
    })
  },
  changeOrderOrderInfoListApi(data = {}) {
    return request({
      url: '/factory/changeOrder/orderInfoList',
      method: 'post',
      data,
    })
  },
  changeOrderAddApi(data = {}) {
    return request({
      url: '/factory/changeOrder/add',
      method: 'post',
      data,
    })
  },
  changeOrderSubmitApi(data = {}) {
    return request({
      url: '/factory/orderInfo/contrast',
      method: 'post',
      data,
    })
  },
})
